import { render } from "./forgot_password.vue?vue&type=template&id=50230f0a&scoped=true"
import script from "./forgot_password.vue?vue&type=script&lang=js"
export * from "./forgot_password.vue?vue&type=script&lang=js"

import "./forgot_password.vue?vue&type=style&index=0&id=50230f0a&scoped=true&lang=css"
import "./forgot_password.vue?vue&type=style&index=1&id=50230f0a&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.3.4_vue@3.3.4_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50230f0a"]])

export default __exports__